import StoreMixin from '@/store/mixin'
import APIMixin from '@/mixins/api'

export default {
  mixins: [APIMixin, StoreMixin],

  data: function () {
    return {
      idleTimeout: null,
      refreshTimeout: null
    }
  },

  methods: {
    async checkToken () {
      try {
        let response = await this.api({
          url: '/users/token'
        })

        this.$store.commit('session', response.data)

        // if (token.startsWith('OTP-')) {
        //  this.forceOTPVerify()
        //  this.$router.push('/otp_verify')
        // }

        return true
      } catch (err) {
        console.log('Error')
        console.log(err)
        this.$store.commit('error', new Error('Token no longer valid, please login again'))
        this.stopIdleWatcher()
        this.forceLogout()
        return false
      }
    },

    hasPermission (permission) {
      if (!permission) {
        return true
      }

      if (typeof this.permissions === 'undefined' || this.permissions.length < 1) {
        return false
      }

      // if (this.force_change_password) {
      //   return false
      // }

      return this.permissions[permission] || this.permissions.superuser

      // if (typeof this.permissions['superuser'] !== 'undefined' && this.permissions['superuser']) {
      //   return true
      // }

      // if (typeof this.permissions[permission] !== 'undefined') {
      //   return this.permissions[permission]
      // }

      // return false
    },

    startIdleWatcher () {
      this.stopIdleWatcher()
      document.addEventListener('keydown', this.actionDetected)
      document.addEventListener('mousedown', this.actionDetected)
      document.addEventListener('scroll', this.actionDetected)
      this.actionDetected()
    },

    stopIdleWatcher () {
      if (this.refreshTimeout) {
        clearTimeout(this.refreshTimeout)
        this.refreshTimeout = null
      }
      if (this.idleTimeout) {
        clearTimeout(this.idleTimeout)
        this.idleTimeout = null
      }
      document.removeEventListener('keydown', this.actionDetected)
      document.removeEventListener('mousedown', this.actionDetected)
      document.removeEventListener('scroll', this.actionDetected)
    },

    actionDetected () {
      if (!this.refreshTimeout) {
        this.refreshTimeout = setTimeout(this.refreshFn, 5 * 60 * 1000)
      }

      if (this.idleTimeout) {
        clearTimeout(this.idleTimeout)
      }

      this.idleTimeout = setTimeout(this.idleFn, 15 * 60 * 1000)
    },

    refreshFn () {
      this.checkToken(this.token)
      this.refreshTimeout = null
    },

    idleFn () {
      this.stopIdleWatcher()
      this.forceLogout()
      const timedOutErrorMessage = 'You have been automatically logged out after 15 minutes of inactivity'
      this.$store.commit('error', {'timed-out-error-message': timedOutErrorMessage})
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/auth.js